<template>
  <li>
    <button
      class="w-full text-left px-6 py-4 flex items-center gap-3 text-xs outline-none hover:bg-blue-100 focus:bg-blue-100"
    >
      <component
        :is="iconComponent"
        aria-hidden
        class="w-5 h-5 text-enterprise-primary flex-shrink-0"
      />
      <div>
        <p>
          {{ notification.message.description }}
          <span v-if="parsedLink" class="underline whitespace-no-wrap">
            <nuxt-link
              v-if="!externalLink"
              :to="parsedLink"
              activeClass="active"
              class="hover:text-enterprise-primary focus:text-enterprise-primary"
              @click.native="trackNotificationClicked"
            >
              {{ notification.message.link_text }}
            </nuxt-link>
            <a
              v-if="externalLink"
              class="hover:text-enterprise-primary focus:text-enterprise-primary"
              :href="parsedLink"
              @click.native="trackNotificationClicked"
            >
              {{ notification.message.link_text }}
            </a>
          </span>
        </p>
      </div>
    </button>
  </li>
</template>

<script>
import { EventBus, Events } from '~/lib/events'

export default {
  components: {},

  props: {
    logo: { type: Object, default: {} },
    notification: { type: Object, required: true },
  },

  data: () => ({}),

  computed: {
    /**
     * Shortcut to the content for this card.
     */
    iconComponent() {
      if (!this.notification.message.icon) return
      return () =>
        import(
          `@/assets/svg/icons/${this.notification.message.icon}.svg?inline`
        )
    },

    parsedLink() {
      if (!this.notification.message.link) {
        return ''
      }

      let linkCopy = this.notification.message.link

      if (this.logo && this.logo.id) {
        linkCopy = linkCopy.replace(/\${logo.id}/g, this.logo.id)
      }

      return linkCopy
    },

    externalLink() {
      return this.notification.message.external_link
    },
  },

  methods: {
    trackNotificationClicked() {
      const notificationName = this.notification.id
        .replace(' ', '_')
        .toLowerCase()

      EventBus.$emit(Events.NotificationClicked, notificationName)
    },
  },
}
</script>
